import React from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { withRouter } from "react-router"

import { getUserData } from "../sessionStorage";

import LoggedInMenu from "./LoggedInMenu";
import OcrProcessDropzone from "./OcrProcessDropzone";
import BankBookingTable from "./BankBookings";

import UploaderButton from "./UploaderButton";
import SearchButton from "./SearchButton";

interface IBankBookingPageProps {
  history: any;
  location: any;
  match: any;
}

class BankBookingPage extends React.Component<IBankBookingPageProps> {
  state: {
    showModal: boolean;
    userFullName: string;
  };

  constructor(props: any) {
    super(props);

    this.state = {
      showModal: false,
      userFullName: "",
    };
  }

  componentDidMount() {
    const userData = getUserData();
    if (userData) {
      let fullName = JSON.parse(userData).fullName;
      this.setState({ userFullName: fullName || "" });
    }
  }

  render() {
    return (
      <>
        <LoggedInMenu history={this.props.history} />
        <OcrProcessDropzone
          show={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
        />
        <div className="content-wrapper">
          <Container fluid>
            <Row>
              <Col xs={12} lg={10} className="main">
                <div className="contentheader">
                  <Container fluid>
                    <Row className="align-items-stretch py-3">
                      <Col xs={6} lg={7}>
                        <UploaderButton
                          onClick={() =>
                            this.setState({
                              ...this.state,
                              showModal: true,
                            })
                          }
                        />
                      </Col>
                      <Col xs={6} lg={5}>
                        <SearchButton
                          history={this.props.history}
                        ></SearchButton>
                      </Col>
                    </Row>
                  </Container>
                </div>
                <BankBookingTable />
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }
}

export default withRouter(BankBookingPage);
